import { Box, Button } from '@chakra-ui/react';

import { useAlert } from '@app/hooks/use-alert';
import { api } from '@app/api';

import Dialog from '../common/modals/dialog';
import { QueryTable } from '../common/table/query-table';

type ClearQRDialogProps = {
  equipId: string;
  open: boolean;
  onClose(): void;
}

export const ClearQRDialog = ({ equipId, open, onClose }: ClearQRDialogProps) => {
  const {refetch} = QueryTable.useQueryTable();

  const { info, error } = useAlert();
  
  const onClearQR = async () => {
    const response = await api.equipments.clearQR(Number(equipId));
    if (response.status !== 200 && response.data.code !== 200) {
      error(`Ошибка: ${response.data.code} - ${response.data.message}`);
      return;
    }
    await refetch();
    info('QR успешно удален');
    onClose();
  };

  return <Dialog title="Удалить QR код?" open={open} onClose={onClose} >
    <Box minWidth={250} display='flex' justifyContent='space-between'>
      <Button colorScheme='brand' onClick={onClearQR}>Да</Button>
      <Button onClick={onClose}>Отмена</Button>
    </Box>
  </Dialog>;
};